import React from 'react';
import Loader from 'utils/Loader';
import ProductCatalogueController from 'pages/Controller/ProductCatalogueController';
import { BASE_URL } from 'Service/ApiService';

function ProductCatalogue() {
  const { loading, handleFileChange, handleUpload, fileInputRef, severity, message, alert } =
    ProductCatalogueController();

  const handleDownload = () => {
    window.location.href = BASE_URL + 'uploads/sample_product_catalogue.csv';
  };

  return (
    <div className="center-container">
      {loading && (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Please wait...</span>
        </div>
      )}

      <div className="white-box">
        <h2 style={{ fontWeight: 'medium', textAlign: 'center' }}>Product Catalogue Upload</h2>
        <div style={{ marginTop: '10px', marginBottom: '10px', float: 'right' }}>
          <button className="sample-download-button" onClick={handleDownload}>
            Sample CSV
          </button>
        </div>

        <div style={{ marginTop: '10px' }}>
          <form onSubmit={handleUpload}>
            <div style={{ marginBottom: '20px' }}>
              <label
                htmlFor="fileInput"
                style={{ fontWeight: 'bold', fontSize: '0.75rem', display: 'block', marginBottom: '4px' }}
              >
                Select File
              </label>
              <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                ref={fileInputRef}
                className="upload-input"
                accept=".csv"
              />
            </div>

            {alert && (
              <div style={{ textAlign: 'left', marginBottom: '10px' }}>
                <span style={{ color: `${severity}` }}>{message}</span>
              </div>
            )}

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="soft-button" type="submit" disabled={loading}>
                UPLOAD
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProductCatalogue;
